export function leadingSlash (str) {
  return str.startsWith('/') ? str : '/' + str
}

export function trailingSlash (str) {
  return str.endsWith('/') ? str : str + '/'
}

export const wait = timeout => {
  return new Promise(resolve => setTimeout(resolve, timeout))
}

export const isDecimal = function (value) {
  return /^-?(?:0|0\.\d*|[1-9]\d*\.?\d*)$/.test(value)
}

export const unmask = function (value, ds = ',') {
  value = (value || '').toString()
  return value.replace(/(?!-)\D/g, '')
}

export const mask = function (value, dp = -1, editing = false, ds = ',', gs = '.') {
  value = (value || '').toString()
  return value.replace(/(?!-)\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
